import axios from "../axios-auth";

export const cityService = {
    getCities,
    getCityDetail,
    saveCity,
    getAllCity
};

function getCityDetail(id) {
    return axios.get("auth/city/" + id);
}
function getCities(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    return axios.get("/auth/cities", { params });
}

function saveCity(city) {
    if (!city.id) {
        // new product
        return axios.post("/auth/city", city);
    } else {
        // edit
        return axios.put("/auth/city", city);
    }
}

function getAllCity() {
    return axios.get("/auth/cities", {});
}